import React from "react";
import { Container } from "react-bootstrap";
import { useIsMobile } from "../utils/responsive";

export default function Footer() {
  const isMobile = useIsMobile();
  return (
    <Container fluid className="p-0">
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            className="border-right-black"
            style={{
              width: "5%",
            }}
          ></div>
        )}
        <div
          style={{
            width: isMobile ? "100%" : "90%",
            padding: isMobile ? "50px" : "50px 100px",
            alignItems: "center",
          }}
        >
          {!isMobile && (
            <h6
              className="text-center heading-xxs"
              style={{
                wordBreak: "break-all",
                overflowWrap: "break-word",
                hyphens: "auto",
              }}
            >
              COPYRIGHT &copy; 2025 KRITIKA GOSWAMY MALIK | ALL RIGHTS RESERVED
            </h6>
          )}
          {isMobile && (
            <>
              {" "}
              <p
                className="text-center body-sm"
                style={{
                  wordBreak: "break-all",
                  overflowWrap: "break-word",
                  hyphens: "auto",
                }}
              >
                COPYRIGHT &copy; 2025
              </p>
              <hr />
              <p
                className="text-center body-sm  "
                style={{
                  wordBreak: "break-all",
                  overflowWrap: "break-word",
                  hyphens: "auto",
                }}
              >
                KRITIKA GOSWAMY MALIK
              </p>
              <hr />
              <p
                className="text-center body-sm"
                style={{
                  wordBreak: "break-all",
                  overflowWrap: "break-word",
                  hyphens: "auto",
                }}
              >
                ALL RIGHTS RESERVED
              </p>
            </>
          )}
        </div>
        {!isMobile && (
          <div
            className="border-left-black "
            style={{
              width: "5%",
            }}
          ></div>
        )}
      </div>
    </Container>
  );
}
